import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  return <KvkkAydinlatmaMetni />
}

export const Route = createFileRoute('/_unauth/privacy-policy')({
  component: RouteComponent,
})



const KvkkAydinlatmaMetni = () => {
  return (
    <article className="max-w-4xl mx-auto p-6 md:p-10 bg-white shadow-sm border border-gray-100 rounded-xl text-gray-700 font-sans">
      {/* Header Section */}
      <header className="mb-8 text-center border-b pb-6 border-gray-200">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
          ÖZEL GÜVENLİK UYGULAMASI
        </h1>
        <h2 className="text-xl md:text-2xl font-semibold text-gray-800">
          KVKK AYDINLATMA METNİ
        </h2>
      </header>

      {/* Intro */}
      <section className="mb-6 space-y-4">
        <p>
          Bu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması
          Kanunu'nun ("KVKK") 10'uncu maddesi ile Aydınlatma Yükümlülüğünün
          Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ
          kapsamında, veri sorumlusu sıfatıyla <strong>TRA BİLİŞİM</strong> (bu
          metinde "TRA" olarak anılacaktır) tarafından hazırlanmıştır.
        </p>
        <p>
          Özel Güvenlik Uygulaması (bu metinde "Uygulama" olarak anılacaktır)
          kapsamında toplanan ve işlenen tüm kişisel veriler, TRA'nın koruması
          altındadır. TRA, KVKK ve ilgili mevzuat uyarınca kişisel verilerin
          güvenli şekilde muhafazasını ve hukuka uygun olarak işlenmesini
          sağlamak amacıyla gerekli teknik ve idari tedbirleri almaktadır.
        </p>
        <p>
          KVKK kapsamında kişisel verileri işlenen gerçek kişiler ("İlgili
          Kişi"), işbu Aydınlatma Metni'ni inceleyerek; hangi kişisel
          verilerinin işlendiği, işlenme amaçları, aktarım yapılan alıcı
          grupları, veri toplama yöntemi ve hukuki sebepler ile KVKK
          kapsamındaki hakları hakkında bilgi edinebilirler.
        </p>
      </section>

      {/* 1. İşlenen Kişisel Veriler */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">
          1. İşlenen Kişisel Verileriniz Nelerdir?
        </h3>
        <p className="mb-3">
          Kişisel veri, kimliği belirli veya belirlenebilir gerçek kişiye
          ilişkin her türlü bilgiyi ifade eder. Uygulama kapsamında
          işlenebilecek kişisel veri kategorileri aşağıda yer almaktadır:
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-gray-500">
          <li>
            <strong>a) Kimlik Bilgileri:</strong> Ad, soyad, doğum tarihi,
            fotoğraf.
          </li>
          <li>
            <strong>b) İletişim Bilgileri:</strong> E-posta adresi.
          </li>
          <li>
            <strong>c) Çalışma Bilgileri:</strong> Şirket adı, departman adı,
            unvan, işe giriş tarihi.
          </li>
        </ul>
      </section>

      {/* 2. Verilerin Toplanma Yöntemi */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">
          2. Kişisel Verileriniz Nasıl Toplanmaktadır?
        </h3>
        <p className="mb-2">Kişisel verileriniz;</p>
        <ul className="list-disc pl-6 space-y-2 mb-4 marker:text-gray-500">
          <li>
            Özel Güvenlik Uygulaması'na ait mobil uygulama, web sitesi ve diğer
            dijital platformlar aracılığıyla,
          </li>
          <li>
            Kayıt formları, anketler, destek talepleri ve uygulama içi iletişim
            kanalları üzerinden,
          </li>
          <li>Açık Rıza Beyanı'nın tarafınızca kabul edilmesi suretiyle,</li>
        </ul>
        <p className="px-3">
          Otomatik veya kısmen otomatik yöntemlerle toplanmaktadır.
        </p>
        <p className="text-sm italic bg-gray-50 p-3 rounded border border-gray-100">
          Uygulama'yı kullanmanız halinde, Gizlilik Politikası ve ilgili mevzuat
          uyarınca kişisel verilerinizin işlenmesine açık rıza göstermiş
          sayılırsınız.
        </p>
      </section>

      {/* 3. İşlenme Amaçları */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">
          3. Kişisel Verileriniz Hangi Amaçlarla İşlenmektedir?
        </h3>
        <p className="mb-4">
          Aşağıda belirtilen kişisel verileriniz, KVKK'ya uygun olarak veri
          sorumlusu sıfatıyla TRA tarafından işlenmektedir:
        </p>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-gray-50 p-4 rounded-lg">
            <h4 className="font-semibold text-gray-900 mb-2 border-b border-gray-200 pb-1">
              İşlenen Veriler
            </h4>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>
                Kayıt formu aracılığıyla paylaşılan kimlik, iletişim ve çalışma
                bilgileri,
              </li>
              <li>Uygulama üzerinden yapılan sesli ve yazılı görüşmeler,</li>
              <li>
                Platform kullanım süresi, oturum bilgileri ve kullanıcı
                aktiviteleri,
              </li>
              <li>Anket ve formlar aracılığıyla sağlanan bilgiler,</li>
              <li>IP adresi, konum bilgisi, cihaz ve tarayıcı bilgileri,</li>
              <li>
                Çerezler ve diğer izleme teknolojileri aracılığıyla elde edilen
                veriler.
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg">
            <h4 className="font-semibold text-gray-900 mb-2 border-b border-gray-200 pb-1">
              İşleme Amaçları
            </h4>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>Uygulama hizmetlerinin sunulması ve geliştirilmesi,</li>
              <li>Kullanıcı deneyiminin iyileştirilmesi,</li>
              <li>Güvenlik ve denetim faaliyetlerinin yürütülmesi,</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi,</li>
              <li>Talep ve şikâyetlerin yönetilmesi,</li>
              <li>Sistem güvenliğinin sağlanması.</li>
            </ul>
          </div>
        </div>
        <p className="mt-4 text-sm">
          Kişisel verileriniz, ilgili mevzuatta öngörülen süreler boyunca
          işlenmektedir.
        </p>
      </section>

      {/* 4. Koruma */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">
          4. Kişisel Verilerinizin Korunması
        </h3>
        <p>
          TRA, kişisel verilerinizin gizliliğini ve güvenliğini sağlamak
          amacıyla yetkisiz erişim, kayıp, ifşa ve hukuka aykırı işlemleri
          önlemek için gerekli tüm teknik ve idari önlemleri almaktadır.
        </p>
      </section>

      {/* 5. Aktarım */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">
          5. Kişisel Verilerin Aktarılması
        </h3>
        <p className="mb-2">
          Kişisel verileriniz, KVKK ve ilgili mevzuata uygun olarak aşağıdaki
          alıcı gruplarına aktarılabilir:
        </p>
        <ul className="list-disc pl-6 space-y-1 mb-3 marker:text-gray-500">
          <li>Yetkili kamu kurum ve kuruluşları,</li>
          <li>Avukatlar, denetçiler, danışmanlar,</li>
          <li>Yetkilendirdiğiniz vekil ve temsilciler,</li>
          <li>Acil durumlarda yetkili merciler.</li>
        </ul>
        <p className="text-sm text-gray-500">
          Üçüncü taraf platformların kendi gizlilik politikalarından TRA sorumlu
          değildir.
        </p>
      </section>

      {/* 6. Yurtdışı */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">
          6. Yurtdışına Aktarım
        </h3>
        <p>
          Açık Rıza Beyanı'nı kabul etmeniz halinde, kişisel verileriniz ilgili
          mevzuata uygun olarak yurt dışına aktarılabilir ve yurt dışında
          bulunan üçüncü kişilerle paylaşılabilir.
        </p>
      </section>

      {/* 7. Çerezler */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">7. Çerezler</h3>
        <p>
          Uygulama kapsamında çerezler kullanılabilir. Çerezlere ilişkin detaylı
          bilgi Çerez Politikası'nda yer almaktadır. Anonim hale getirilen
          veriler, kullanıcı rızası aranmaksızın analiz ve istatistik amaçlı
          paylaşılabilir.
        </p>
      </section>

      {/* 8. Değişiklikler */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">
          8. Politika Değişiklikleri
        </h3>
        <p>
          TRA, işbu Aydınlatma Metni'nde değişiklik yapma hakkını saklı tutar.
          Yapılan değişiklikler Uygulama üzerinden yayımlandığı tarihten
          itibaren yürürlüğe girer.
        </p>
      </section>

      {/* 9. Haklar */}
      <section className="mb-8">
        <h3 className="text-lg font-bold text-gray-900 mb-3">
          9. KVKK Kapsamındaki Haklarınız
        </h3>
        <p className="mb-2">
          KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:
        </p>
        <ul className="list-disc pl-6 space-y-1 marker:text-gray-500">
          <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
          <li>İşlenmişse bilgi talep etme,</li>
          <li>İşlenme amacını öğrenme,</li>
          <li>Aktarılan üçüncü kişileri bilme,</li>
          <li>Düzeltme, silme veya yok edilmesini isteme,</li>
          <li>Otomatik sistemlerce yapılan işlemlere itiraz etme,</li>
          <li>Zarara uğramanız halinde tazminat talep etme.</li>
        </ul>
        <p>haklarına sahipsiniz.</p>
      </section>

      {/* 10. Gizlilik Politikası Referansı */}
      <section className="border-t pt-6 mt-8">
        <h3 className="text-lg font-bold text-gray-900 mb-2">
          10. Gizlilik Politikası
        </h3>
        <p>
          Özel Güvenlik Uygulaması'na ilişkin gizlilik esasları, işbu Aydınlatma
          Metni'nin ayrılmaz bir parçasıdır ve TRA tarafından yürürlükteki
          mevzuata uygun şekilde uygulanır.
        </p>
      </section>
    </article>
  )
}
